(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bp-navigation"] && !Shopify.designMode) return;
  try {
    class BPNavigation extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const options = { signal: this.abort.signal };
    this.addEventListener('toggle', event => {
      const branch = event.target;
      if (!(branch instanceof HTMLDetailsElement) || !branch.open) return;
      const list = branch.parentElement.parentElement;
      if (list.tagName === 'UL') {
        for (const item of list.children) {
          const sibling = item.querySelector(':scope > details');
          if (sibling && sibling !== branch) sibling.open = false;
        }
      }
      if (branch.classList.contains('bp-top') && this.classList.contains('bp-desktop')) {
        const panel = branch.querySelector(':scope > ul');
        const parent = this.getBoundingClientRect();
        const anchor = branch.querySelector('summary').getBoundingClientRect();
        const left = Math.max(16, Math.min(anchor.left - parent.left, parent.width - panel.offsetWidth - 16));
        panel.style.setProperty('--bp-panel-left', left + 'px');
      }
    }, { ...options, capture: true });
    this.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const branch = event.target.closest('details[open]');
      if (branch) {
        branch.open = false;
        branch.querySelector(':scope > summary').focus();
        event.preventDefault();
        event.stopPropagation();
      }
    }, options);
    document.addEventListener('click', event => {
      if (!this.contains(event.target)) this.close();
    }, options);
    this.addEventListener('focusout', event => {
      if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
    }, options);
    window.addEventListener('resize', () => this.close(), options);
  }
  close() {
    this.querySelectorAll('details[open]').forEach(branch => { branch.open = false; });
  }
  disconnectedCallback() { this.abort.abort(); }
}
if (!customElements.get('bp-navigation')) customElements.define('bp-navigation', BPNavigation);
  } catch(e) { console.error(e); }
})();

})();
